"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _components = require("./components");

var _core = require("@emotion/core");

const Label = _stylitas.styled.label`
  ${_components.radioInputLabel};
  ${_components.radioInputLabelError};
`;
const RadioInputDiv = _stylitas.styled.div`
  ${_components.radioInputItem};
`;
const Span = _stylitas.styled.span`
  ${_components.radioInputButton};
`;
const RadioInp = _stylitas.styled.input`
  ${_components.inputStyle};
  ${_components.inputStyleChecked};
`;
const propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes.string.isRequired,
  id: _propTypes.string.isRequired,
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  value: _propTypes.any,
  name: _propTypes.string,
  checked: _propTypes.bool,
  fullWidth: _propTypes.bool,
  error: _propTypes.bool
} : {};
const defaultProps = {
  checked: false,
  error: false,
  fullWidth: false
};

const RadioInput = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  const {
    id,
    name,
    label,
    value,
    onChange,
    onBlur,
    fullWidth,
    checked,
    error,
    ...otherProps
  } = props;
  return (0, _core.jsx)(RadioInputDiv, null, (0, _core.jsx)(RadioInp, (0, _extends2.default)({
    type: "radio",
    name: name,
    id: id,
    value: value,
    ref: ref,
    checked: checked,
    onChange: onChange,
    onBlur: onBlur
  }, otherProps)), (0, _core.jsx)(Label, {
    error: error,
    htmlFor: id,
    fullWidth: fullWidth
  }, (0, _core.jsx)("div", null, (0, _core.jsx)(Span, {
    checked: checked
  }), label)));
});

exports.RadioInput = RadioInput;
process.env.NODE_ENV !== "production" ? RadioInput.propTypes = propTypes : void 0;
RadioInput.defaultProps = defaultProps;